import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import financialPlanningImageWebp from './images/top-ranked.webp';
// styles

export default () => {
  return (
    <InformationalModule
      sectionId='financial-information-financial-planning-3'
      moduleName='financial-planning-module'
      moduleVariation='A'
      themeType='lightTheme'
      // content
      subHeadingText={<>We&#39;re established.</>}
      // column content
      columnContentA={(
        <Typography disableBottomPadding>
          In 2025, Northwestern Mutual was once again named one of the World&#39;s Most Admired Companies&#174; in our industry according to <strong><em>FORTUNE&#174;</em></strong>&#39;s annual survey. Additionally, securing the &#35;109 spot on the <strong><em>FORTUNE</em></strong> 500&#174; list in 2025 affirms that Northwestern Mutual is among America&#39;s premier financial service companies and a beacon of financial strength and stability.
        </Typography>
      )}
      // image props
      imageAltText='Top ranked in our industry'
      imageSrcDefault={financialPlanningImageWebp.toString()}
    />
  );
};
